import {Fragment} from 'react'

import {Button} from 'primereact/button'
import React from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import StyledDeleteDialog from './StyledDeleteDialog'
const StyledCardListWrapper = ({
    children,
    handleAddNew,
    className,
    initialData,
    template,
    handleAction,
    handleOnDelete,
    title,
    description,
    isAdd = true,
    isDelete = true,
    isEdit = true,
}) => {
    const deleteRef = React.useRef()
    const {translateCommons} = TranslateUtils()

    return (
        <Fragment>
            {title && description && (
                <div className=" flex justify-content-between p-2 mb-3 align-items-end">
                    <div>
                        {' '}
                        <h3 className="pt-2 mb-0 font-bold text-3xl md:text-4xl   text-teal-700">
                            {title}
                        </h3>
                        <p>{description}</p>
                    </div>
                    <div>
                        <Button
                            label="Add New"
                            icon="pi pi-plus"
                            onClick={handleAddNew}
                        />
                    </div>
                </div>
            )}

            <div className={` ${className} w-full flex flex-column`}>
                {/* Minimal Header */}

                <div className="grid">
                    {/* Minimal Add Contact Card */}
                    {/* {isAdd && (
                        <div className="justify-center items-center md:col-12 lg:col-4 xl:col-3">
                            <div
                                className="border-1 border-gray-300 hover:border-teal-500 border-dashed border-round-lg p-4 cursor-pointer transition-all transition-duration-200   flex flex-column items-center gap-2 ml-auto h-full align-items-center justify-content-center"
                                onClick={handleAddNew}>
                                <div className="w-3rem h-3rem  flex flex-column align-items-center justify-content-center group-hover:border-blue-400 group-hover:bg-blue-50 transition-all mx-2  ">
                                    <DuoPlus />
                                </div>
                                <div className="text-gray-600 text-sm font-bold">
                                    ADD NEW
                                </div>
                            </div>
                        </div>
                    )} */}

                    {initialData &&
                        initialData.length > 0 &&
                        initialData.map((item, idx) => (
                            <div
                                key={item.id || idx}
                                className="col-12 md:col-12 lg:col-4 xl:col-3 cursor-pointer ">
                                <div
                                    className="shadow-1 border-round-lg p-2 py-3 h-full 
                                transition-all transition-duration-200 
                                overflow-hidden flex flex-column relative hover:border-teal-500">
                                    {template(item)}
                                    <div className="flex align-items-center justify-content-between gap-2">
                                        <Button
                                            className="h-3rem p-button-text w-full border-teal-200"
                                            icon="pi pi-pencil"
                                            label="Edit"
                                            onClick={() => handleAction(item)}
                                        />
                                        <Button
                                            className="h-3rem p-button-text bg-red-50 hover:bg-red-100 text-red-500 w-full"
                                            icon="pi pi-trash"
                                            label="Remove"
                                            onClick={() =>
                                                deleteRef.current.showForm(item)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                    {!isDelete && children}

                    {(!initialData || initialData.length === 0) && (
                        <div className="col-12">
                            <div className="text-center py-8">
                                <div className="w-4rem h-4rem bg-gray-100 border-circle flex align-items-center justify-content-center mx-auto mb-3">
                                    <i className="pi pi-users text-gray-400 text-xl"></i>
                                </div>
                                <h4 className="text-600 font-normal m-0 mb-2">
                                    No data yet
                                </h4>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <StyledDeleteDialog ref={deleteRef} onDelete={handleOnDelete} />
        </Fragment>
    )
}
export default StyledCardListWrapper
